import React, { memo, useContext, useState } from 'react'
import '../../../../styles/sortableData.scss'
import CloseIcon from '@mui/icons-material/Close'
import { Button, Dialog, useMediaQuery, useTheme } from '@mui/material'
import { CheckCircleOutline } from '@mui/icons-material'
import { format } from 'date-fns'
import PopupHistorialPagos from './PopupHistorialPagos'
import TableDataPagination, { INITIAL_ROWS_PER_PAGE } from '../../../../pages/Products/components/TableDataPagination'
import ModalCardsPagos from './CardsPagos'
import { DataContratosContext, LinksLocal, PagosLocal } from '../../context/data.contratos.context'

export interface PropsDataContratos {
  show: boolean
  loading: boolean
  data: LinksLocal | PagosLocal
  handleClose: any
  headers?: string[]
  title: string
  codLocal?: string
}

const ModalTablePagos: React.FC<PropsDataContratos> = ({
  show,
  loading,
  data,
  handleClose,
  headers,
  title
}: PropsDataContratos) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [openHistorial, setOpenHistorial] = useState<boolean>(false)
  const [idContratoHistorial, setIdContratoHistorial] = useState<number>(null)
  const [historialPago, setHistorialPago] = useState<any[]>(null)

  const showHideClassName = show ? 'modal display-block' : 'modal display-none'
  const { paginatorPagos, setPagePagos, setPageSizePagos, pagePagos, pageSizePagos } = useContext(DataContratosContext)

  paginatorPagos.handleChangePage = (e: any, newPage: number) => {
    setPagePagos(newPage)
  }

  paginatorPagos.handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPageSizePagos(parseInt(event.target.value, 10))
    setPagePagos(0)
  }

  const closeRenovations = () => {
    handleClose()
  }

  const handleOpenHistorial = (item: any) => {
    setIdContratoHistorial(item.idContrato)
    setHistorialPago(item.historialCambios)
    setOpenHistorial(true)
  }

  if (loading) return

  return (
    <>
      {isMobile ? (
        <ModalCardsPagos
          show={show}
          loading={loading}
          data={data}
          handleClose={handleClose}
          headers={headers}
          title={title}
          handleOpenHistorial={handleOpenHistorial}
        />
      ) : (
        <div className={showHideClassName}>
          <section
            className="modal-main"
            style={{
              marginTop: '20px',
              overflowY: 'auto',
              maxHeight: '80vh',
              width: '90%'
            }}
          >
            <header className="contract-actions-header">
              <h3 className="contract-actions-title">{title !== undefined && title}</h3>
              <button className="modal-close" onClick={closeRenovations} aria-label="Cerrar">
                <CloseIcon />
              </button>
            </header>
            <div style={{ paddingRight: '7.5vh' }}>
              <table className="table table-striped table-bordered premise-table">
                <thead className="table-active">
                  <tr>
                    {headers &&
                      headers.map((h: any, index) => {
                        return (
                          <th key={index}>
                            <button type="button">{h}</button>
                          </th>
                        )
                      })}
                  </tr>
                </thead>
                {data.items.length > 0 && (
                  <tbody>
                    {data.items.map((item: any, index) => {
                      const fecha = new Date(item.fechaPago)
                      return (
                        <>
                          <tr key={item.idContratoPago}>
                            <th>{`Pago: ${item.contratoPagoEstado}`}</th>
                            <th>
                              {`Pagado: ${item.monto}`}
                              {item.montoDevuelto > 0 && `\nDevuelto: ${item.montoDevuelto}`}
                              {item.saldoAplicado > 0 && `\nSaldo Aplicado: ${item.saldoAplicado}`}
                            </th>
                            <th>{item.pagoNroOperacion}</th>
                            <th>{format(fecha, 'dd/MM/yyyy HH:mm')}</th>
                            <th>
                              {item.mensajeResultado}
                              {item.nuevoContrato && (
                                <CheckCircleOutline style={{ marginLeft: '8px', color: 'green' }} />
                              )}
                            </th>
                            <th className="columWithButton">
                              <Button variant="outlined" size="small" onClick={() => setOpenHistorial(true)}>
                                Historial de cambios
                              </Button>
                            </th>
                          </tr>
                        </>
                      )
                    })}
                  </tbody>
                )}
                <tfoot>
                  <tr>
                    <TableDataPagination
                      total={data.totalItems || 0}
                      page={pagePagos || 0}
                      paginator={paginatorPagos}
                      items={data.items || []}
                      rowsPerPage={pageSizePagos || INITIAL_ROWS_PER_PAGE}
                      component={'td'}
                      label={`Pagos por página`}
                    />
                  </tr>
                </tfoot>
              </table>
            </div>
          </section>
        </div>
      )}

      <Dialog open={openHistorial}>
        <PopupHistorialPagos
          idContrato={idContratoHistorial}
          open={openHistorial}
          setOpen={setOpenHistorial}
          elements={historialPago}
        />
      </Dialog>
    </>
  )
}

export default memo(ModalTablePagos)
